import { ConfigOptions, MainMenu, SubMenuOption, SubMenuType } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import hideDoors from 'rangeConfig/shared/behaviors/hideDoors';
import { frameTypeFilter } from 'rangeConfig/platsa/filters/configFilters';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import framesProductListConfig from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import ProductSortFilterWidget from 'rangeConfig/shared/widgets/ProductSortFilterWidget';
import {
  depthFilter,
  heightFilterWithSizeLabel,
  widthFilter
} from 'rangeConfig/shared/filters/configFilters';
import ShapeHelpLinesMenu from 'components/HelpLines/ShapeHelpLinesMenu';
import {
  optimizeSpaceBehaviour,
  disableHelplineEditMode,
  enableHelplineEditMode,
  showOptimizeSpaceTabWhenEnteringFrames
} from 'rangeConfig/platsa/behaviors/optimizeSpace';
import AutoFillOptimiseSpace from 'rangeConfig/platsa/features/Autofill/widgets/AutoFillOptimiseSpace';

const tabs: SubMenuOption[] = [
  {
    id: 'frame-single-frames-tab',
    title: 'storageone.mainMenuFramesTabSingleFrames',
    widgets: [
      {
        id: 'frames-sort-filter-widget',
        component: ProductSortFilterWidget
      },
      { id: 'frames-product-list', component: withProducts(ProductList, framesProductListConfig) }
    ]
  },
  {
    id: 'frame-recommendations-tab',
    title: 'storageone.mainMenuFramesTabOptimiseSpace',
    behaviors: {
      subMenuEntered: [optimizeSpaceBehaviour],
      subMenuExited: [disableHelplineEditMode]
    },
    widgets: [
      {
        id: 'wall-shape',
        component: ShapeHelpLinesMenu
      },
      {
        id: 'autofill',
        component: AutoFillOptimiseSpace
      }
    ]
  }
];

const widgets = {
  desktop: [],
  mobile: [
    {
      id: 'frame-product-list',
      component: withProducts(ProductSwiper, framesProductListConfig),
      title: 'storageone.productListFramesTitle'
    }
  ]
};

const mainMenu = (options?: ConfigOptions): MainMenu => {
  const productGroupEntered = [hideDoors];
  if (options?.featureFlags?.optimizeSpaceDefault) {
    productGroupEntered.push(enableHelplineEditMode);
  }

  return {
    menuTitle: 'storageone.productListFramesTitle',
    behaviors: {
      productGroupEntered,
      productGroupExited: [showDoors, disableHelplineEditMode]
    },
    filters: [frameTypeFilter, heightFilterWithSizeLabel, widthFilter, depthFilter],
    widgets: widgets[platform],
    subMenu: {
      type: SubMenuType.TABS,
      options: tabs,
      initiallySelectedTab: coreApi =>
        options?.featureFlags?.optimizeSpaceDefault
          ? showOptimizeSpaceTabWhenEnteringFrames(coreApi)
          : tabs[0].id
    }
  };
};

export default mainMenu;
